import React from 'react';
import blockStyles from '@baseStyles/block.scss';
import styles from './ContentB2.scss';
import Slider from '@components/base/Slider/Slider';
import {Autoplay, Pagination} from "swiper/modules";
import 'swiper/css/pagination';
import ContentB1 from "@components/blocks/ContentB1/ContentB1";
import {useScreenSizeBelowBreakpoint} from "@hooks/useScreenSizeBelowBreakpoint";

const ContentB2 = ({data, color = ''}) => {
	if (!data) {
		return null;
	}

	const isValidData = Array.isArray(data.blockContent) && data.blockContent.every(item => item.title && item.desc);

	if (isValidData === false) {
		return null;
	}

	const isMobile = useScreenSizeBelowBreakpoint(600);

	return (
	  <>
		  <div className={blockStyles.baseContainerHolder}>
			  <ContentB1 title={data.blockTitle} desc={data.blockDesc} size={'800'}/>
		  </div>

		  <div className={`${styles.container} ${color ? blockStyles[color] : ''}`}>
			  <Slider
				modules={[Pagination, Autoplay]}
				slidesPerView={'auto'}
				showPagination={true}
				playInViewPortOnly={true}>
				  {data.blockContent.map((val, key) => (
					<div key={key}>

						{/* TEXT */}
						{/*///////////////////////////////////////////////////////////////////////////////*/}
						<div className={styles.textHolder}>
							<div
							  className={styles.title}
							  dangerouslySetInnerHTML={{__html: val.title}}>
							</div>

							<div
							  className={styles.desc}
							  dangerouslySetInnerHTML={{__html: isMobile ? val.descMobile : val.desc}}>
							</div>
						</div>
						{/*///////////////////////////////////////////////////////////////////////////////*/}

					</div>
				  ))}
			  </Slider>
		  </div>
	  </>
	)
}

export default ContentB2;
